import { useQueries } from '@tanstack/react-query';
import { api } from '../services/api';
import { flattenDepartments } from '../utils/attendanceUtils';

const useAttendanceData = (scope, selectedDeptId, employees) => {
  const [deptsQ, empsQ, schedulesQ, absenceQ, companyQ] = useQueries({
    queries: [
      {
        queryKey: ['attendance-data-departments'],
        queryFn: () =>
          api.get('v1/organization-chart/').then((res) =>
            flattenDepartments(res.data?.organization_chart || [])
          ),
      },
      {
        queryKey: ['attendance-data-employees', scope, selectedDeptId],
        queryFn: async () => {
          const params = { limit: 1000, employee_status: 'ACTIVE' };
          if (scope === 'department' && selectedDeptId) params.department_id = selectedDeptId;
          const res = await api.get('v1/employees/', { params });
          return res.data?.employees || res.data || [];
        },
        enabled: scope !== 'manual' || !employees?.length,
      },
      {
        queryKey: ['attendance-data-schedules'],
        queryFn: () =>
          api.get('v1/schedules/', { params: { limit: 200 } }).then(
            (res) => res.data?.schedules || res.data || []
          ),
      },
      {
        queryKey: ['attendance-data-absence-reasons'],
        queryFn: () =>
          api.get('v1/absence-reasons', { params: { is_active: true, limit: 200 } }).then(
            (res) => (Array.isArray(res.data?.items) ? res.data.items : [])
          ),
      },
      {
        queryKey: ['attendance-data-company'],
        queryFn: () =>
          api.get('v1/companies/').then((res) => res.data?.company ?? null),
      },
    ],
  });

  return {
    departments: deptsQ.data ?? [],
    employees: empsQ.data ?? [],
    schedules: schedulesQ.data ?? [],
    absenceReasons: absenceQ.data ?? [],
    companyInfo: companyQ.data ?? null,
  };
};

export default useAttendanceData;
